import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:8081",
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
});

let isRefreshing = false;
let pendingQueue = [];

const processQueue = (error) => {
    pendingQueue.forEach(({ resolve, reject }) => error ? reject(error) : resolve());
    pendingQueue = [];
};

axiosInstance.interceptors.response.use(
    res => res,
    async err => {
        const original = err.config;
        // Only attempt refresh on 401, only once per request, and not for auth endpoints
        if (
            err.response?.status === 401 &&
            !original._retried &&
            !original.url?.includes('/api/app_user/login') &&
            !original.url?.includes('/api/app_user/refresh')
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    pendingQueue.push({ resolve, reject });
                }).then(() => axiosInstance(original));
            }
            original._retried = true;
            isRefreshing = true;
            try {
                await axiosInstance.post('/api/app_user/refresh');
                processQueue(null);
                return axiosInstance(original);
            } catch (refreshErr) {
                processQueue(refreshErr);
                // Refresh failed — only redirect if not already on an auth page
                const PUBLIC_PATHS = ['/', '/login', '/register', '/forgot-password', '/reset-password',
                    '/confirm-email', '/oauth-callback', '/tours', '/rentals', '/about', '/contact',
                    '/faq', '/privacy', '/terms'];
                const onPublicPage = PUBLIC_PATHS.includes(window.location.pathname) ||
                    window.location.pathname.startsWith('/tours/') ||
                    window.location.pathname.startsWith('/bike-travel-offers');
                if (!onPublicPage) {
                    window.location.href = '/login';
                }
                return Promise.reject(refreshErr);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(err);
    }
);

export default axiosInstance;
